"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const localize_1 = require("../localize");
(function () {
    'use strict';
    // Create global objects
    window.gs1 = window.gs1 || {};
    TYPO3.lang = TYPO3.lang || {};
    TYPO3.settings = TYPO3.settings || {};
    TYPO3.settings.Gs1CompleteOrder = TYPO3.settings.Gs1CompleteOrder || {};
    TYPO3.settings.Gs1CompleteOrder.countriesWithVat = TYPO3.settings.Gs1CompleteOrder.countriesWithVat || {};
    var exports = {
        initializeSelectbox: function () {
            var $selectbox = $('[data-selectbox-select2="true"]');
            $selectbox.each(function () {
                var $curSelectbox = $(this);
                var $target = $($curSelectbox.attr('data-selectbox-formatted-option-target'));
                if ($target.length > 0) {
                    $curSelectbox.select2({
                        minimumResultsForSearch: Infinity,
                        theme: 'gs1',
                        templateResult: function (state) {
                            if (!state.id || !$target) {
                                return state.text;
                            }
                            return $target.find('[data-option-value="' + state.id + '"]').clone();
                        }
                    });
                    $curSelectbox.on('change', function (event) {
                        $('.select2-selection__rendered', $curSelectbox.next('.select2')).html($target.find('[data-option-value="' + $curSelectbox.val() + '"]').clone()).css({ 'white-space': 'normal' });
                    });
                    $curSelectbox.trigger('change');
                }
                else {
                    $curSelectbox.select2({
                        minimumResultsForSearch: Infinity,
                        theme: 'gs1'
                    });
                }
            });
        },
        /**
         * Initialize display of the cost element - GSONE-1836
         */
        initializeAdditionalCharges: function () {
            var orderItemSelected = $("input[name='tx_gs1completeorder_form[newApplication][orderItems]']:checked").val();
            var currentAdditionalCharge = $('label[for=order_items_' + orderItemSelected + ']')
                .find('[data-price-num-article-numbers]')
                .data('priceNumArticleNumbers');
            $('#additional_shipping_charge').html(currentAdditionalCharge);
        },
        /**
         * Get cart contents in SS1|SS10|UDI|Complete|IFS and Cloud4Log (C4L) order forms
         */
        getCartContents: function (cartUri, $cartWrapper) {
            // $cartWrapper.
            // Quick Fix: Do not attach throbber for Safari because it causes a complete freeze
            // in combination with active scriptmerger
            // ToDo: Find and resolve causation
            var agent = navigator.userAgent.toLowerCase();
            if (agent.indexOf('safari') < 0) {
                $cartWrapper.attachThrobber();
            }
            $cartWrapper.find('.cart-contents').fadeTo(0.333, 0.3);
            var $form = $cartWrapper.closest('form');
            var params = $form.serializeArray();
            if (typeof cartUri !== 'undefined' && cartUri !== '') {
                $.ajax({
                    type: 'POST',
                    url: cartUri,
                    data: params,
                    dataType: 'html',
                    cache: false,
                    async: true,
                    success: function (response) {
                        $cartWrapper.html(response);
                        exports.attachCartModals();
                    }
                });
            }
        },
        /**
         * Workaround for failed modal migration
         * @todo Refactoring required
         */
        attachCartModals: function () {
            const modal = document.querySelectorAll('[data-gs1-cart-modal]'), documentBody = document.querySelector('body'), infoText = document.querySelectorAll('[rel="gs1-cart-modal"]');
            if (modal) {
                modal.forEach((item) => {
                    item.addEventListener("click", (event) => {
                        const documentBlocker = document.querySelector('.modal__blocker');
                        const el = event.target;
                        (el.classList.contains('modal__inner-icon')) ? item.classList.add('hidden') : '';
                        (el.classList.contains('modal__inner-icon')) ? documentBlocker.remove() : '';
                    });
                    item.addEventListener("click", (event) => {
                        const uiBlocker = document.querySelector('.modal__blocker');
                        (uiBlocker) ? uiBlocker.remove() : '';
                        item.classList.add('hidden');
                    });
                    item.addEventListener("keydown", (event) => {
                        const uiBlocker = document.querySelector('.modal__blocker');
                        if (event.key === "Escape") {
                            (uiBlocker) ? uiBlocker.remove() : '';
                            item.classList.add("hidden");
                        }
                    });
                });
                // Toggle info texts in product comparison table
                if (infoText) {
                    infoText.forEach((item) => {
                        item.addEventListener("click", (event) => {
                            event.preventDefault();
                            const el = event.target;
                            const anchorElement = event.currentTarget;
                            const anchor = el.parentElement.parentElement;
                            const infoTextModal = document.getElementById(`${(anchorElement != anchor) ? anchorElement.hash.split('#')[1] : anchor.hash.split('#')[1]}`);
                            (infoTextModal.classList.contains('hidden')) ? infoTextModal.classList.remove('hidden') : '';
                            const documentBlocker = document.createElement('div');
                            documentBlocker.classList.add('modal__blocker');
                            (documentBlocker) ? documentBody.appendChild(documentBlocker) : '';
                            (el.classList.contains('modal__inner-icon')) ? item.classList.add('hidden') : '';
                            (el.classList.contains('modal__inner-icon')) ? documentBlocker.remove() : '';
                        });
                    });
                }
            }
        },
        /**
         * Check if element exists on page and update the cart.
         */
        attachCartEvents: function () {
            if ($('#complete_cart_wrapper').length) {
                var $cartWrapper = $('#complete_cart_wrapper');
                if (typeof cartUri === 'undefined') {
                    cartUri = "";
                }
                $cartWrapper.empty();
                $('.field-wrap-orderItems, .field-wrap-annualTurnover')
                    .find('select, input').on('change', function () {
                    exports.getCartContents(cartUri, $cartWrapper);
                    // Show fancybox if orderitems < 10000 and turnover group >= 3
                    var annualTurnoverSelected = parseInt($('#annualTurnover').val());
                    var orderItemsSelected = parseInt($("input[name='tx_gs1completeorder_form[newApplication][orderItems]']:checked").val());
                    if (annualTurnoverSelected >= 3 && orderItemsSelected < 10000) {
                        var hasTurnoverSelectedMessageContent = parseInt($('#info_annualTurnoverThreshold').data('hasTurnoverSelectedMessageContent'));
                        if (hasTurnoverSelectedMessageContent === 1) {
                            const annualTurnoverThreshold = document.querySelector('#info_annualTurnoverThreshold');
                            if (annualTurnoverThreshold.classList.contains('hidden')) {
                                annualTurnoverThreshold.classList.remove('hidden');
                            }
                            const documentBlocker = document.createElement('div');
                            documentBlocker.classList.add('modal__blocker');
                            if (documentBlocker) {
                                document.querySelector('body').appendChild(documentBlocker);
                            }
                        }
                    }
                });
                $('.field-wrap-selectedCert input, #companyCountry, .field-wrap-shipping').on('change', function () {
                    exports.getCartContents(cartUri, $cartWrapper);
                });
                this.getCartContents(cartUri, $cartWrapper);
            }
        },
        /**
         * Attach event to toggle display of TAC w/ and w/o GTIN-Manager
         */
        attachTacEvents: function () {
            $('.field-wrap-shipping')
                .find('select, input').on('change', function () {
                if ($('#shipping_2').is(':checked')) {
                    // Show extended TAC
                    $('#tac-default').hide();
                    $('#tac-w-gtinmgr').show();
                }
                else {
                    // Hide extended TAC
                    $('#tac-default').show();
                    $('#tac-w-gtinmgr').hide();
                }
            });
        },
        /**
         * additional price for receiving article numbers via email has to change variably dependent on the selected
         * offer
         */
        attachAdditionalCharges: function () {
            $('.field-wrap-orderItems input').on('change', function () {
                var currentAdditionalCharge = $('label[for=' + $(this).attr('id') + ']')
                    .find('[data-price-num-article-numbers]')
                    .data('priceNumArticleNumbers');
                $('#additional_shipping_charge').html(currentAdditionalCharge);
                var currentShippingAmountFormatted = $('label[for=' + $(this).attr('id') + ']')
                    .find('[data-shipping-amount-formatted]')
                    .data('shippingAmountFormatted');
                $('.shipping-amount-formatted').html(currentShippingAmountFormatted);
            });
        },
        /**
         * GS1 Certificate Radio Element Manipulation
         */
        attachCertificatSelectionEvents: function () {
            $('#selectedCert_1').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#selectedCert').val($(this).val());
                    $('#selectedCert_2, #selectedCert_3').prop('checked', false);
                }
                else {
                    $('#selectedCert').val('');
                }
            });
            $('#selectedCert_2').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#selectedCert').val($(this).val());
                    $('#selectedCert_1, #selectedCert_3').prop('checked', false);
                }
                else {
                    $('#selectedCert').val('');
                }
            });
            $('#selectedCert_3').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#selectedCert').val($(this).val());
                    $('#selectedCert_1, #selectedCert_2').prop('checked', false);
                }
                else {
                    $('#selectedCert').val('');
                }
            });
        },
        attachVatNumberSelectionEvents: function () {
            if (typeof (TYPO3) !== 'undefined'
                && typeof (TYPO3.settings) !== 'undefined'
                && typeof (TYPO3.settings.Gs1) !== 'undefined'
                && typeof (TYPO3.settings.Gs1.countriesWithVat) !== 'undefined') {
                var countryField = $('#companyCountry'), vatNumberField = $('#companyTaxId'), vatNumberFieldWrap = vatNumberField.closest('.form-group'), toggleVatNumberField = function (toggle) {
                    if (!toggle) {
                        vatNumberField.val('');
                    }
                    vatNumberFieldWrap.toggle(toggle);
                }, checkVatNumberField = function () {
                    toggleVatNumberField($.inArray(countryField.val(), TYPO3.settings.Gs1.countriesWithVat) !== -1);
                };
                checkVatNumberField();
                countryField.on('change', function () {
                    checkVatNumberField();
                });
            }
        },
        /**
         * Toggle the terms and conditions for SS1/SS10/GS1 Complete Upgrades
         */
        attachTermsAndConditionsToggleEvents: function () {
            var packageSelectionToggle = $('input[name="tx_gs1completeorder_smartstarter1upgradeform[upgradeRequest][package]"]'), toggleTermsAndConditions = function () {
                var selectedPackage = $('input[name="tx_gs1completeorder_smartstarter1upgradeform[upgradeRequest][package]"]:checked').val(), termsAndConditionsSs10 = $('#termsAndConditionsSs10'), termsAndConditionsSsComplete = $('#termsAndConditionsSsComplete');
                if (parseInt(selectedPackage) === 2) {
                    termsAndConditionsSs10.css('display', 'none');
                    termsAndConditionsSsComplete.css('display', 'inline');
                }
                else {
                    termsAndConditionsSs10.css('display', 'inline');
                    termsAndConditionsSsComplete.css('display', 'none');
                }
            };
            packageSelectionToggle.on('click', function () {
                toggleTermsAndConditions();
            });
        },
        /**
         * Disable payment methods if not available for all countries. See TypoScript settings
         * in EXT:gs1_payone for details and configuration
         * @see GSONE-1872
         */
        attachCountrySelectionEvents: function () {
            var countryField = $('#companyCountry'), availablePaymentTypes = $('.field-wrap-paymentType').find('input[type="radio"]'), togglePaymentMethod = function (disablePaymentType, element) {
                var label = $("label[for='" + $(element).attr('id') + "']");
                var container = $("div[for='" + $(element).attr('id') + "']");
                if (disablePaymentType) {
                    element.prop('disabled', true).prop('checked', false);
                    container.css('display', 'none');
                    $(label).addClass('payment-type-disabled').attr('title', (0, localize_1.Localize)('payment.message.typeNotAvailable', 'Zahlungsart für das gewählte Land nicht verfügbar.'));
                }
                else {
                    element.prop('disabled', false);
                    container.css('display', '');
                    $(label).removeClass('payment-type-disabled').attr('title', '');
                }
            }, updateAvailablePaymentMethods = function () {
                if (typeof (TYPO3) !== 'undefined') {
                    availablePaymentTypes.each(function () {
                        var $paymentTypeElement = $(this);
                        var $paymentType = $paymentTypeElement.val();
                        var $paymentMethodCountryRestrictions = TYPO3.settings.Gs1CompleteOrder.paymentMethodCountryRestrictions[$paymentType];
                        if ($paymentMethodCountryRestrictions.length > 0) {
                            togglePaymentMethod($.inArray(countryField.val(), $paymentMethodCountryRestrictions) === -1, $paymentTypeElement);
                        }
                    });
                }
            };
            countryField.on('change', function () {
                updateAvailablePaymentMethods();
            });
        },
        /**
         * Allow users to paste code into field one and distribute it
         * across all three fields of reorder code form.
         * @see GSONE-1869
         */
        attachPasteCodeEvents: function () {
            var firstCodeSegement = $('#codeOne'), parseAndDistributePastedCode = function (pastedCode) {
                pastedCode = pastedCode.trim();
                pastedCode = pastedCode.replace(/\s/g, '');
                var codeParts = pastedCode.split('-');
                if (codeParts.length === 3) {
                    $('#codeOne').val(codeParts[0]);
                    $('#codeTwo').val(codeParts[1]);
                    $('#codeThree').val(codeParts[2]);
                }
                else {
                    $('#codeOne').val(codeParts[0].substr(0, 3));
                }
            };
            firstCodeSegement.on('paste', function () {
                var element = this;
                setTimeout(function () {
                    var pastedCode = $(element).val();
                    parseAndDistributePastedCode(pastedCode);
                }, 100);
            });
        },
        attachBranchSelectionEvents: function () {
            $('#companyBranch').on('change', function (event) {
                const selectedOption = this.options[this.selectedIndex];
                if (selectedOption && selectedOption.value) {
                    const value = selectedOption.value;
                    const prefix = value.substring(0, 4);
                    const num = parseInt(prefix, 10);
                    const infoBoxHealthCareInstitution = document.querySelector('#info_lightboxContentForBranch14xx');
                    const healthCareBranchIds = [1404];
                    if (healthCareBranchIds.includes(num) && infoBoxHealthCareInstitution) {
                        // Modal for Healthcare / 14xx
                        (infoBoxHealthCareInstitution.classList.contains('hidden')) ? infoBoxHealthCareInstitution.classList.remove('hidden') : '';
                        const documentBlocker = document.createElement('div');
                        documentBlocker.classList.add('modal__blocker');
                        (documentBlocker) ? document.querySelector('body').appendChild(documentBlocker) : '';
                    }
                    const infoBoxFinanceInstitution = document.querySelector('#info_lightboxContentForBranch15xx');
                    const financeBranchIds = [1502, 1504, 1501, 1503];
                    if (financeBranchIds.includes(num) && infoBoxFinanceInstitution) {
                        // Modal for Finance / 15xx
                        (infoBoxFinanceInstitution.classList.contains('hidden')) ? infoBoxFinanceInstitution.classList.remove('hidden') : '';
                        const documentBlocker = document.createElement('div');
                        documentBlocker.classList.add('modal__blocker');
                        (documentBlocker) ? document.querySelector('body').appendChild(documentBlocker) : '';
                    }
                }
            });
        },
        initializeErrorMessageHandling: function () {
            $('.complete-layout').find('.mandatory-message').find('a').on('click', function (event) {
                event.preventDefault();
                var $anchor = $(this);
                var $targetElement = $('#' + $anchor.attr('href').split('#').pop());
                if ($targetElement.length > 0) {
                    var targetOffset = $targetElement.offset().top;
                    $('html,body').animate({
                        scrollTop: targetOffset
                    }, 500, function () {
                        $targetElement.trigger('focus');
                        $targetElement.trigger('select');
                    });
                }
            });
        },
        /**
         * Disable the submit button in OBS after submit (a.k.a. poor man's double click/double order prevention)
         */
        attachSubmitFormEvents: function () {
            $('form[name="newApplication"]').submit(function () {
                $(this).find('button[type=submit]').prop('disabled', true);
            });
        }
    };
    exports.initializeErrorMessageHandling();
    exports.initializeSelectbox();
    exports.initializeAdditionalCharges();
    exports.attachCertificatSelectionEvents();
    exports.attachCartEvents();
    exports.attachTacEvents();
    exports.attachAdditionalCharges();
    exports.attachCertificatSelectionEvents();
    exports.attachVatNumberSelectionEvents();
    exports.attachCountrySelectionEvents();
    exports.attachTermsAndConditionsToggleEvents();
    exports.attachPasteCodeEvents();
    exports.attachBranchSelectionEvents();
    exports.attachSubmitFormEvents();
    $('.complete-success-inner').find('h4').addClass('h3');
    $('.complete-layout').find('.contentbox-inline-info').find('h4').addClass('h3');
})();
exports.default = {};
